import type { ReactNode } from 'react';
import { createContext, useCallback, useContext, useState } from 'react';

type ConsultEligibleCalendarContextType = {
  showCalendar: boolean;
  emailAddress: string;
  handleShowCalendar: () => void;
  handleEmailAddress: (email: string) => void;
};

export const ConsultEligibleCalendarContext = createContext<ConsultEligibleCalendarContextType>({
  showCalendar: false,
  emailAddress: '',
  handleShowCalendar: () => {},
  handleEmailAddress: () => {},
});

export const ConsultEligibleCalendarProvider = ({ children }: { children: ReactNode }) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const [emailAddress, setEmailAddress] = useState('');

  const handleShowCalendar = useCallback(() => {
    setShowCalendar(true);
  }, []);

  const handleEmailAddress = useCallback((email: string) => {
    setEmailAddress(email);
  }, []);

  return (
    <ConsultEligibleCalendarContext.Provider
      value={{ showCalendar, emailAddress, handleShowCalendar, handleEmailAddress }}
    >
      {children}
    </ConsultEligibleCalendarContext.Provider>
  );
};

export const useConsultEligibleCalendar = () => {
  const context = useContext(ConsultEligibleCalendarContext);

  if (!context) {
    throw new Error('useCalendarContext must be used within CalendarProvider');
  }
  return context;
};
